import { Host, h } from '@stencil/core';
export class AibaTabList {
  constructor() {
    this.activeTab = '';
    this.styles = undefined;
    this.classes = undefined;
    this.activeTabHandler = undefined;
    this.detailArray = undefined;
  }
  setActiveTab(tab, event) {
    this.activeTab = tab;
    this.activeTabHandler && this.activeTabHandler(event);
  }
  componentWillLoad() {
    if (this.detailArray) {
      this.activeTab = this.detailArray[0]['title'];
    }
  }
  componentDidLoad() {
    this.tabLoaded.emit();
  }
  renderTabs() {
    var _a;
    return (h("div", { class: "tab-container__tabs" }, (_a = this.detailArray) === null || _a === void 0 ? void 0 : _a.map((tab) => {
      return (h("div", { class: `tab aiba-font-variant-body ${tab.title === this.activeTab ? 'tab--active' : ''}`, tabIndex: 0, onClick: (event) => this.setActiveTab(`${tab.title}`, event) }, tab.title));
    })));
  }
  renderContent(activeTab) {
    return this.detailArray.map((item) => {
      return h("div", { class: `tab-container__content  ${item.title === activeTab ? 'active' : ''}` }, item.content);
    });
  }
  render() {
    if (typeof this.detailArray === 'string') {
      this.detailArray = JSON.parse(this.detailArray);
    }
    return (h(Host, { class: this.classes ? this.classes : '' }, this.styles && h("style", null, this.styles), h("div", { class: "tab-container" }, this.renderTabs(), this.renderContent(this.activeTab))));
  }
  static get is() { return "aiba-tab-list"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-tab-list.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-tab-list.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "activeTabHandler": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "active-tab-handler",
        "reflect": false
      },
      "detailArray": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "detail-array",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "activeTab": {}
    };
  }
  static get events() {
    return [{
        "method": "tabLoaded",
        "name": "tabLoaded",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        }
      }];
  }
}
//# sourceMappingURL=aiba-tab-list.js.map
